import { colorPalette } from '../../style/colorPalette'

const LockOpenIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 15 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        d="M6 12C6.4125 12 6.76563 11.8531 7.05938 11.5594C7.35313 11.2656 7.5 10.9125 7.5 10.5C7.5 10.0875 7.35313 9.73438 7.05938 9.44063C6.76563 9.14688 6.4125 9 6 9C5.5875 9 5.23438 9.14688 4.94063 9.44063C4.64688 9.73438 4.5 10.0875 4.5 10.5C4.5 10.9125 4.64688 11.2656 4.94063 11.5594C5.23438 11.8531 5.5875 12 6 12ZM1.5 15.75C1.0875 15.75 0.734375 15.6031 0.440625 15.3094C0.146875 15.0156 0 14.6625 0 14.25V6.75C0 6.3375 0.146875 5.98438 0.440625 5.69063C0.734375 5.39688 1.0875 5.25 1.5 5.25H6.75V3.75C6.75 2.7125 7.11563 1.82813 7.84688 1.09688C8.57812 0.365625 9.4625 0 10.5 0C11.5375 0 12.4219 0.365625 13.1531 1.09688C13.8844 1.82813 14.25 2.7125 14.25 3.75H12.75C12.75 3.125 12.5313 2.59375 12.0938 2.15625C11.6562 1.71875 11.125 1.5 10.5 1.5C9.875 1.5 9.34375 1.71875 8.90625 2.15625C8.46875 2.59375 8.25 3.125 8.25 3.75V5.25H10.5C10.9125 5.25 11.2656 5.39688 11.5594 5.69063C11.8531 5.98438 12 6.3375 12 6.75V14.25C12 14.6625 11.8531 15.0156 11.5594 15.3094C11.2656 15.6031 10.9125 15.75 10.5 15.75H1.5Z"
        fill={colorPalette.skyBlue[2]}
      />
    </svg>
  )
}

export default LockOpenIcon
